import React, { useRef, useState } from "react";
import { message } from "antd";
import { IdfaImportResult, importIdfaReports } from "../../api/idfaReports";

export const importSummary = (result: IdfaImportResult) => {
  const left = result.files.length - result.importedFiles;
  return [
    `${result.importedFiles} of ${result.files.length} files imported`,
    `${result.importedRows.toLocaleString("en-US")} rows`,
    left ? `${left} not imported` : null,
  ]
    .filter(Boolean)
    .join(" · ");
};

/**
 * A hidden file input behind any button: `open` picks the contractor's
 * archive (or one .xlsx) and sends it, to `target` when given.
 */
const useIdfaUpload = (
  onImported: (result: IdfaImportResult) => void,
  target?: { orderType: string; orderId: number },
) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [uploading, setUploading] = useState(false);

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    // The same file may be picked again after a fix.
    event.target.value = "";
    if (!file) return;
    setUploading(true);
    try {
      const result = await importIdfaReports(file, target);
      onImported(result);
      if (result.importedFiles) message.success(importSummary(result));
      else message.warning("No file was imported, see the reasons below");
    } catch (error: any) {
      message.error(error?.message || "The archive was not imported");
    } finally {
      setUploading(false);
    }
  };

  return {
    uploading,
    open: () => inputRef.current?.click(),
    input: (
      <input
        ref={inputRef}
        type="file"
        accept=".zip,.xlsx"
        hidden
        onChange={handleChange}
      />
    ),
  };
};

export default useIdfaUpload;
